<template>
  <div class="box box-info">
    <div class="box-header with-border" v-if="!showFilters">
      Área: <strong>{{ functional_area_name }}</strong> - Semana:
      <strong>{{ currentFilters.date_from }}</strong> a
      <strong>{{ currentFilters.date_to }}</strong>
      <div class="box-tools pull-right">
        <a href="#" @click.prevent="showFilters = true">[Cambiar]</a>
      </div>

      <template v-if="statusFetched">
        <el-alert
          title="Período cerrado"
          type="warning"
          show-icon
          :closable="false"
          v-if="statusClosed"
        >
          <div
            class="box-tools pull-right"
            v-if="this.$auth.can(['shifts.open_period'])"
          >
            <el-button
              type="primary"
              icon="el-icon-edit"
              @click="handleOpenPeriod"
              >Reabrir</el-button
            >
          </div>
          <div v-if="1">
            El período seleccionado ya fue liquidado y no se permiten
            modificaciones
          </div>
        </el-alert>
        <el-alert
          title="Período activo"
          type="info"
          show-icon
          :closable="false"
          v-if="!statusClosed && this.$auth.can(['shifts.close_period'])"
        >
          <div class="box-tools pull-right">
            <el-button
              type="danger"
              icon="el-icon-close"
              @click="handleClosePeriod"
              >Cerrar</el-button
            >
          </div>
          <div v-if="!statusPartiallyClosed">
            El período seleccionado aún permite modificaciones
          </div>
          <div v-else>
            Los siguientes períodos se encuentran cerrados y no permiten
            modificaciones: <strong>{{ closedPeriods }}</strong>
          </div>
        </el-alert>
      </template>
    </div>

    <div class="box-header with-border" v-else>
      <h3 class="box-title">Filtrar</h3>

      <div class="box-tools pull-right">
        <button
          type="button"
          class="btn btn-box-tool"
          @click="showFilters = false"
          data-original-title="Cancelar"
        >
          <i class="fa fa-times"></i>
        </button>
      </div>
      <div class="box-body">
        <el-form
          :inline="true"
          :model="filters"
          ref="filtersForm"
          class="demo-form-inline"
          v-if="showFilters"
        >
          <el-row :gutter="20">
            <el-col :xs="24" :sm="12" :md="8" :lg="8">
              <el-form-item
                label="Área"
                prop="functional_area_id"
                required
                :rules="[{ required: true, message: 'Campo requerido' }]"
                label-width="75px"
              >
                <el-select
                  v-model="filters.functional_area_id"
                  filterable
                  placeholder="Filtre / Seleccione"
                  style="width: 200px"
                >
                  <el-option
                    v-for="item in functional_areas_for_user"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value"
                  >
                  </el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :xs="24" :sm="12" :md="8" :lg="8">
              <el-form-item
                label="Semana"
                prop="date_from"
                required
                :rules="[{ required: true, message: 'Campo requerido' }]"
                label-width="75px"
              >
                <el-week-picker
                  style="width: 200px"
                  :value="filters.date_from"
                  @input="weekPickerChange"
                  type="week"
                  format="yyyy-MM-dd"
                  align="right"
                  placeholder="Seleccione una semana"
                >
                </el-week-picker>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row
            ><el-col :span="24" style="text-align: right">
              <el-form-item>
                <el-button type="primary" @click="handleFilter"
                  >Filtrar</el-button
                >
              </el-form-item>
              <el-form-item>
                <el-button type="info" @click="handleClearFilters"
                  >Limpiar</el-button
                >
              </el-form-item>
            </el-col></el-row
          >
        </el-form>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters, mapActions } from "vuex";
import el_week_picker from "../el-week-picker.vue";

export default {
  props: {
    statusFetched: false,
    statusClosed: false,
    statusPartiallyClosed: false,
    closedPeriods: "",
    currentFilters: {
      type: Object,
      default: {
        functional_area_id: null,
        date_from: null,
        date_to: null,
      },
    },
  },
  data() {
    return {
      showFilters:
        this.currentFilters.functional_area_id == null ||
        this.currentFilters.date_from == null ||
        this.currentFilters.date_to == null,
      filters: {
        functional_area_id: this.currentFilters.functional_area_id,
        date_from: this.currentFilters.date_from,
        date_to: this.currentFilters.date_to,
      },
    };
  },
  computed: {
    ...mapGetters(["functional_areas_for_user"]),
    functional_area_name: function () {
      let item = _.find(this.functional_areas_for_user, (item) => {
        return item.value == this.currentFilters.functional_area_id;
      });
      if (item != undefined) {
        return item.label;
      } else {
        return "-";
      }
    },
    dateRangeLabel: function () {
      return `Fechas (entre ${this.currentFilters.date_from} y ${this.currentFilters.date_to})`;
    },
  },
  mounted() {
    this.fetchFunctionalAreasForUser();
  },
  watch: {
    currentFilters: {
      handler(value, o) {
        // console.log('currentFilters change');
        // console.log(value);
        this.filters = Object.assign({}, value);
        this.showFilters =
          value.functional_area_id == null ||
          value.date_from == null ||
          value.date_to == null;
      },
      deep: true,
    },
  },
  components: {
    "el-week-picker": el_week_picker,
  },
  methods: {
    ...mapActions(["fetchFunctionalAreasForUser"]),
    checkDateRange(rule, value, callback) {
      let date_from = moment(value[0]).format("YYYY-MM-DD");
      let date_to = moment(value[1]).format("YYYY-MM-DD");
      if (
        date_from >= this.currentFilters.date_from &&
        date_to <= this.currentFilters.date_to
      ) {
        let date = date_from;
        while (date <= date_to) {
          let st = this.status.find(
            (elem) => elem.date_from <= date && elem.date_to >= date
          );
          if (st != undefined && st.status == "CLO") {
            callback(
              new Error(
                "Alguno de los días seleccionados corresponden a períodos cerrados."
              )
            );
          }
          date = moment(date).add(1, "d").format("YYYY-MM-DD");
        }
        callback();
      } else {
        callback(
          new Error("Las fechas deben corresponder a la semana seleccionada.")
        );
      }
    },
    weekPickerChange(value) {
      this.filters.date_from = value[0];
      this.filters.date_to = value[1];
    },
    handleFilter() {
      this.$refs["filtersForm"].validate((valid) => {
        if (valid) {
          let query = {};
          _.each(this.filters, (value, key) => {
            if (this.filters[key] != null) {
              query[key] = this.filters[key];
            }
          });
          this.checkedEmployees = [];
          this.$router.push({ path: this.$route.path, query });
          this.showFilters = false;
          // this.employeesTableVisible = true;
        } else {
          console.log("error submit!!");
          return false;
        }
      });
    },
    handleClearFilters() {
      this.filters.functional_area_id = null;
      this.filters.date_from = null;
      this.filters.date_to = null;
      this.currentFilters.functional_area_id = null;
      this.currentFilters.date_from = null;
      this.currentFilters.date_to = null;
      let query = {};
      this.$router.push({ path: this.$route.path, query });
      // this.employeesTableVisible = false;
      // this.assignments = [];
    },
    handleClosePeriod() {
      let data = {
        aspect: "SA",
        date_from: this.filters.date_from,
        date_to: this.filters.date_to,
        status: "CLO",
      };
      axios
        .post(
          "/api/functionalareas/" +
            this.filters.functional_area_id +
            "/statusbydate",
          data
        )
        .then((response) => {
          // console.log('handleClosePeriod response');
          // this.$refs['dataTable'].fetchItems();
          // this.loadInfo(this.$route.query);
          this.$emit("statusChanged");
        });
    },
    handleOpenPeriod() {
      let data = {
        aspect: "SA",
        date_from: this.filters.date_from,
        date_to: this.filters.date_to,
        status: "OPE",
      };
      axios
        .post(
          "/api/functionalareas/" +
            this.filters.functional_area_id +
            "/statusbydate",
          data
        )
        .then((response) => {
          // console.log('handleOpenPeriod response');
          // this.$refs['dataTable'].fetchItems();
          // this.loadInfo(this.$route.query);
          this.$emit("statusChanged");
        });
    },
  },
};
</script>